import React from "react";
import { useI18n } from "../i18n";
import { C, R, S } from "../theme";

// Full-screen busy overlay shown while a (synchronous) PDF is generated, so the
// UI doesn't appear frozen on larger date-range exports.
export default function GeneratingOverlay({ label }) {
  const { t: tr } = useI18n();
  label = label || tr("gen.generatingPdf");
  return (
    <div data-testid="generating-overlay" style={{ position: "fixed", inset: 0, zIndex: 12000, background: "rgba(0,0,0,0.62)", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: C.card, borderRadius: R.lg, padding: S.xl, display: "flex", flexDirection: "column", alignItems: "center", gap: S.md, border: `1px solid ${C.borderStrong}`, minWidth: 220 }}>
        <div className="spin" style={{ width: 44, height: 44, borderRadius: "50%", border: `4px solid ${C.card2}`, borderTopColor: C.amber }} />
        <div style={{ color: C.text, fontWeight: 800, fontSize: 15 }}>{label}</div>
      </div>
    </div>
  );
}
